import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';
import { ReportIdentityCard, joinDisplayValues } from '../../reports/shared/report-table-cells';

export function getProfileDisplayName(profile) {
  return [profile?.firstName, profile?.lastName]
    .filter((part) => part != null && String(part).trim() !== '')
    .join(' ')
    .trim();
}

export function ProfileListIdentityCell({
  row,
  extraLines = [],
  companyKey = 'companyName',
  jobKey,
  emailKey,
  showNoPhotoHint = false,
  noPhotoHint,
}) {
  const card = (
    <ReportIdentityCard
      title={getProfileDisplayName(row)}
      lines={[
        joinDisplayValues([row?.[companyKey], jobKey ? row?.[jobKey] : null]),
        emailKey ? row?.[emailKey] : null,
        ...extraLines,
      ]}
    />
  );

  if (!showNoPhotoHint) {
    return card;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, minWidth: 0, width: '100%' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>{card}</Box>
      <Tooltip title={noPhotoHint} arrow>
        <Box
          component="span"
          sx={{ display: 'inline-flex', color: 'warning.main', flexShrink: 0, mt: 0.5 }}
        >
          <Icon icon="mdi:image-off-outline" width={18} height={18} />
        </Box>
      </Tooltip>
    </Box>
  );
}

ProfileListIdentityCell.propTypes = {
  row: PropTypes.object,
  extraLines: PropTypes.arrayOf(PropTypes.node),
  companyKey: PropTypes.string,
  jobKey: PropTypes.string,
  emailKey: PropTypes.string,
  showNoPhotoHint: PropTypes.bool,
  noPhotoHint: PropTypes.node,
};

export function createProfileIdentityColumn({
  headerName = 'Profile',
  minWidth = 240,
  flex = 1.4,
  extraLines,
  companyKey,
  jobKey,
  emailKey,
  getShowNoPhotoHint,
  noPhotoHint,
} = {}) {
  return {
    field: 'lastName',
    headerName,
    minWidth,
    flex,
    renderCell: (params) => (
      <ProfileListIdentityCell
        row={params.row}
        extraLines={typeof extraLines === 'function' ? extraLines(params.row) : extraLines}
        companyKey={companyKey}
        jobKey={jobKey}
        emailKey={emailKey}
        showNoPhotoHint={Boolean(getShowNoPhotoHint?.(params.row))}
        noPhotoHint={noPhotoHint}
      />
    ),
  };
}
